import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.addressSection.title',
    defaultMessage: 'Addresses',
    description: 'Title of the address section',
  },
  editButton: {
    label: {
      id: 'pages.addressSection.editButton.label',
      defaultMessage: 'Change',
      description: 'Label of the change button in the address section',
    },
  },
  billing: {
    title: {
      id: 'pages.addressSection.billing.title',
      defaultMessage: 'Billing address',
      description: 'Title of the billing in the address section',
    },
    emptyMessage: {
      id: 'pages.addressSection.billing.emptyMessage',
      defaultMessage: 'No billing address',
      description: 'Empty message of the shipping in the address section',
    },
  },
  shipping: {
    title: {
      id: 'pages.addressSection.shipping.title',
      defaultMessage: 'Shipping address',
      description: 'Title of the shipping in the address section',
    },
    emptyMessage: {
      id: 'pages.addressSection.shipping.emptyMessage',
      defaultMessage: 'No shipping address',
      description: 'Empty message of the billing in the address section',
    },
  },
};

export default defineMessages(translations);
